import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In listening experiments, it is possible to perceptually evaluate the quality of the simulation and the auralization. This can be achieved by comparing the simulation-based auralizations with measurement-based auralizations.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [0.5, 5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Authenticity",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    letterSpacing: "3.5px",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_STATIC_URL}/0330/lesson_3_28_Authenticity.html`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data:
                    "The test for authenticity is designed in the way so that the listener has ideal conditions to detect differences. Auralizations using noise burst can be played back as often the participant likes. If participants fail to reliably identify X in this ABX test, A and B can be considered as equal.",
                  direction: "row",
                  color: "default",
                },
              },
              styles: {
                width: "600px",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
